import { Modal } from "react-bootstrap";
import GradientButton from "../../../Core/GradientButton";

export default function ComingSoonModal(props) {
	return 	<Modal show={ props.show }>
				<Modal.Header>
					<h3>
						Coming Soon
					</h3>
				</Modal.Header>
				<Modal.Body>
					<p>This feature is not available yet.</p>
				</Modal.Body>
				<Modal.Footer>
					<GradientButton title="OK" variant="greenYellow" onClick={() => props.onOKClicked()} />
				</Modal.Footer>
			</Modal>
}